import ReactCustomFlagSelect from './ReactCustomFlagSelect';
if (typeof window !== 'undefined') {
  (<any>window).ReactCustomFlagSelect = ReactCustomFlagSelect;
}

export default ReactCustomFlagSelect;
